<template>
	<Slider :sliders="sliders"></Slider>
</template>

<script>
import Slider from "@/components/Pages/CategorySlider";

export default {
	components: { Slider },

	data() {
		return {
			sliders: [
				{
					title: "Impermeabilizante",
					name: "Acriterm 3 años",
					color: "#CE0E45",
					categories: [7, 75],
					img: "/img/acriterm3años.png",
					description:
						"Es un impermeabilizante elastomérico, formulado a base de resinas estiren-acrílicas de la más alta calidad, creado para evitar el deterioro provocado por la humedad, además de brindar protección a azoteas de concreto, láminas de asbesto, cemento, madera entre muchas otras alargando la vida de las superficies hasta por 3 años garantizados.",
				},

				{
					title: "Impermeabilizante",
					name: "Acriterm 5 años",
					color: "#723187",
					categories: [7, 76],
					img: "/img/acriterm5años.png",
					description:
						"Es un impermeabilizante elastomérico, formulado a base de resinas estiren-acrílicas de la más alta calidad, creado para evitar el deterioro provocado por la humedad, además de brindar protección a azoteas de concreto, láminas de asbesto, cemento, madera entre muchas otras alargando la vida de las superficies hasta por 5 años garantizados.",
				},

				{
					title: "Impermeabilizante",
					name: "Acriterm 7 años",
					color: "#BE5600",
					categories: [7, 77],
					img: "/img/acriterm7años.png",
					description:
						"Es un impermeabilizante elastomérico fibratado, formulado a base de resinas estiren-acrílicas de la más alta calidad, creado para evitar el deterioro provocado por la humedad, además de brindar protección a azoteas de concreto, láminas de asbesto, cemento, madera entre muchas otras alargando la vida de las superficies hasta por 3 años garantizados.",
				},
			],
		};
	},
};
</script>

<style lang="css" scoped></style>
